import { Button, Col, Divider, notification, Popconfirm, Row, Switch } from 'antd';
import { viewersApi } from 'api/viewUserApi';
import { useAppSelector } from 'app/hooks';
import ActivateViewer from 'components/Common/Modal/ActivateViewer';
import AddEditFormViewers from 'components/Common/Modal/AddEditFormViewers';
import { selectIsDisable } from 'features/Login/authSlice';
import { ViewerInfo } from 'models/viewers';
import * as React from 'react';
import { FiChevronLeft, FiEdit } from 'react-icons/fi';
import style from './ViewerInfo.module.scss';
import ListOfPlant from './ListOfPlant';
// import { selectGatewayInfo } from './gatewaySlice';
export interface ViewerInformationProps {
  isShowViewerDetail: boolean;
  setIsShowViewerDetail: (value: boolean) => void;
  setViewerList: (value: ViewerInfo[]) => void;
  setItemViewer: (value: ViewerInfo) => void;
  itemViewer: ViewerInfo;
}

export default function ViewerInformation({
  isShowViewerDetail,
  setIsShowViewerDetail,
  setViewerList,
  itemViewer,
  setItemViewer,
}: ViewerInformationProps) {
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  const [isModalVisibleEdit, setIsModalVisibleEdit] = React.useState<boolean>(false);
  const isEvent: boolean = true;
  const isDisable = useAppSelector(selectIsDisable);

  const openNotificationWithIcon = (type: string, message: string) => {
    if (type === 'success' || type === 'error') notification[type]({ message: message });
    return;
  };

  const onDeleteItemViewer = async (value: string) => {
    await viewersApi.remove(value);
    const res = await viewersApi.fetchViewers({ _limit: 5, _page: 0 });
    setViewerList(res.data);
    openNotificationWithIcon('success', 'Delete viewer successfully');
    setIsShowViewerDetail(!isShowViewerDetail);
  };

  const onChange = async (checked: boolean) => {
    try {
      await viewersApi.fetchViewerEnabled({ id: itemViewer?.id, type: checked });
      await setItemViewer({ ...itemViewer, status: checked ? 'enabled' : 'checked' });
      const res = await viewersApi.fetchViewers({ _limit: 5, _page: 0 });
      setViewerList(res.data);
      openNotificationWithIcon('success', 'Change viewer successfully');
    } catch (error) {
      openNotificationWithIcon('error', 'Change viewer Failed!');
    }
  };

  return itemViewer ? (
    <Row className={style.root}>
      <Row className={style.header_info}>
        <Col lg={13} xl={16} className={style.header_label_info}>
          <FiChevronLeft
            style={{ marginRight: '5px', cursor: 'pointer' }}
            onClick={() => setIsShowViewerDetail(!isShowViewerDetail)}
          />

          {itemViewer.email}
        </Col>
        <Col lg={11} xl={8} className={style.header_group_btn}>
          {itemViewer.status === 'not activated' ? (
            <Button
              disabled={isDisable}
              className={style.btn_activate}
              onClick={() => {
                setIsModalVisible(!isModalVisible);
              }}
            >
              Activate
            </Button>
          ) : (
            <Switch
              disabled={isDisable}
              defaultChecked={itemViewer.status.toLowerCase() === 'enabled'}
              onChange={onChange}
            />
          )}
          <Popconfirm
            placement="bottomLeft"
            title="Sure to delete?"
            onConfirm={() => onDeleteItemViewer(itemViewer.id)}
          >
            <Button disabled={isDisable} className={style.btn_delete}>
              Delete
            </Button>
          </Popconfirm>
          <Button
            disabled={isDisable}
            className={style.btn_edit}
            onClick={() => {
              setIsModalVisibleEdit(!isModalVisibleEdit);
            }}
          >
            Edit
            <FiEdit style={{ marginLeft: '10px' }} />
          </Button>
        </Col>
      </Row>
      <div className={style.main_detail}>
        <Divider orientation="left" plain style={{ fontWeight: 'bold' }}>
          Viewer Info
        </Divider>
        <div className={style.content_plant_information}>
          <Col span={4} className={style.text_plant_information}>
            Email
          </Col>
          <Col span={20} className={style.values_plant_information}>
            {itemViewer.email}
          </Col>
        </div>
        <div className={style.content_plant_information}>
          <Col span={4} className={style.text_plant_information}>
            Name
          </Col>
          <Col span={20} className={style.values_plant_information}>
            {itemViewer.first_name} {itemViewer.last_name}
          </Col>
        </div>
        <ListOfPlant itemViewer={itemViewer} />
      </div>
      <ActivateViewer
        itemViewer={itemViewer}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        setItemViewer={setItemViewer}
        setViewerList={setViewerList}
      />
      <AddEditFormViewers
        isEvent={isEvent}
        itemViewer={itemViewer}
        isModalVisible={isModalVisibleEdit}
        setIsModalVisible={setIsModalVisibleEdit}
        setViewerList={setViewerList}
      />
    </Row>
  ) : null;
}
